<template>
  <div class="mt-2" id="event-list-view">
    <!-- for the top of the panel - might have to move elsewhere later -->
    <v-expansion-panels :multiple="true" v-model="activePanels"
                        v-if="!activeListIsEmpty && !emptyPageBypass">
      <v-expansion-panel v-for="(tournament) in activeEventsList" v-bind:key="tournament.id"
                         v-show="tournament.events.length > 0">
        <v-expansion-panel-header expand-icon="krypt-arrow-down"
        >
          <span style="margin-right:8px;"
                v-if="selectedSport ==='none' && selectedCategory ==='none'">{{ $t(`sports.${tournament.tournament.sportIdentifier}`)}} - {{tournament.tournament.category}} - {{tournament.tournament.name}}</span>
          <span style="margin-right:8px;"
                v-if="selectedSport !=='none' && selectedTournament ==='none' && selectedCategory ==='none'">{{tournament.tournament.category}} - {{tournament.tournament.name}}</span>
          <span style="margin-right:8px;" v-if="selectedCategory !=='none'">{{tournament.tournament.name}}</span>
          <span style="margin-right:8px;"
                v-if="selectedTournament !=='none'">{{tournament.title}}</span>
        </v-expansion-panel-header>
        <!--        <v-expansion-panel-header expand-icon="krypt-arrow-down"-->
        <!--                                  v-if="selectedTournament !=='none'">-->
        <!--          <span style="margin-right:8px;">{{tournament.title}}</span>-->
        <!--        </v-expansion-panel-header>-->
        <v-expansion-panel-content>
          <v-container>
            <v-row v-for="(event) in tournament.events" v-bind:key="event.id"
                   class="event-row"
                   no-gutters
            >
              <template>
                <v-col class="event-time-cell top-border-event-cell "
                       v-bind:class="{'event-is-live': (event.status === 'Live'||
                    event.status === 'Suspended'||
                    event.status === 'Interrupted'||
                    event.status === 'Abandoned') && event.eventType !== 'Virtual' && event.bookingStatus === 'Booked'}"
                >
                  <div class="time-cell-text" v-show="!(event.status === 'Live' && typeof event.matchStatus === undefined)" v-html="processTimeCellInfo(event)"></div>

                  <img :src="LiveLabelIcon" style="max-height:16px;" v-if="
                     event.bookingStatus === 'Booked' &&
                    (event.status === 'Live'||
                    event.status === 'Suspended'||
                    event.status === 'Interrupted'||
                    event.status === 'Abandoned')
                    "
                  >


                </v-col>
                <v-col
                  @click="selectEvent(event)"
                  class="event-information-cell top-border-event-cell d-flex flex-column justify-center">
                  <div class="event-info-wrapper">
                    <div class="score-wrapper"
                         v-if="event.status !== 'Not_Started' && event.status !=='MatchAboutToStart' && typeof event.matchStatus !=='undefined'">
                      <span class="score-text">{{event.matchStatus.homeScore}}</span>
                      <span class="score-text top-margin-2">{{event.matchStatus.awayScore}}</span>
                    </div>
                    <div class="teams-wrapper">
                      <span class="team-info-text"
                            v-if="event.eventType ==='Match'">{{event.homeTeam}}</span>
                      <span class="team-info-text"
                            v-if="event.eventType ==='Race'">{{event.name}}</span>
                      <span class="team-info-text"
                            v-if="event.eventType ==='Virtual'">{{event.name}}</span>
                      <span class="team-info-text top-margin-2" v-if="event.eventType ==='Match'">{{event.awayTeam}}</span>
                    </div>
                  </div>
                  <span class="matched-content top-margin-3"><span
                    class="matched-text">{{$t('eventsList.matched')}}:&nbsp;</span><span
                    class="matched-value">{{$store.state.userCurrency}}{{event.volume!=null ? event.volume : 0 | numberWithCommasNoDecimals}}</span></span>
                </v-col>
                <v-col class=" event-icons-cell top-border-event-cell">
                  <!-- the class is not required at all and is not used anyway -> the conditions never resolve to true
                       v-bind:class="{'bordered-event-cell':((marketsGroupedByEvents[event.id] && typeof marketsGroupedByEvents[event.id].mainMarket !== 'undefined'
                     && typeof marketsGroupedByEvents[event.id].mainMarket.runners.length < 4)||
                     (marketsGroupedByEvents[event.id] && typeof marketsGroupedByEvents[event.id].mainMarket === 'undefined'
                      && marketsGroupedByEvents[event.id].mainMarket.runners.length <4))
                     }"
                > -->
                  <div class="user-bet-counter-lay "
                       v-if="eventsWithBets[event.id] && eventsWithBets[event.id].matched.length !==0">
                    <span class="">{{eventsWithBets[event.id].matched.length}}</span>
                  </div>
                  <div class="user-bet-counter-back "
                       v-if="eventsWithBets[event.id] && eventsWithBets[event.id].unmatched.length !==0">
                    <span class="">{{eventsWithBets[event.id].unmatched.length}}</span>
                  </div>
                  <div class="match-info-icon"
                       v-if="event.bookingStatus  ==='Booked' && event.status === 'Not_Started'">
                    <!-- v-if="!isMobile"> -->
                    <v-icon
                      size="24"
                      color="#A0A3A5"
                    >
                      krypt-live
                    </v-icon>
                  </div>
                  <div class="match-info-icon"
                       v-if="streamMappings.hasOwnProperty(event.remoteId) && streamMappings[event.remoteId].streams !=='' && (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended')">
                    <!-- v-if="!isMobile"> -->
                    <v-icon
                      size="24"
                      color="#A0A3A5"
                      @click="selectEventForStream(event)"
                    >
                      krypt-live-video
                    </v-icon>
                  </div>
                  <div class="match-info-icon"
                       @click="selectEventForLiveCenter(event)"
                       v-if="event.bookingStatus  ==='Booked' && (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended')">
                    <v-icon
                      size="24"
                      color="#A0A3A5"
                    >
                      krypt-field
                    </v-icon>
                  </div>

                  <!--                  <div class="match-info-icon">-->
                  <!--                    <v-icon-->
                  <!--                      size="24"-->
                  <!--                      color="#A0A3A5"-->
                  <!--                    >-->
                  <!--                      krypt-stats-->
                  <!--                    </v-icon>-->
                  <!--                  </div>-->
                </v-col>
                <template
                  v-if="marketsGroupedByEvents[event.id] &&
                !(typeof marketsGroupedByEvents[event.id].mainMarket === 'undefined'||(marketsGroupedByEvents[event.id].mainMarket.isDummyMainMarket === true) || marketsGroupedByEvents[event.id].mainMarket.runners.length >3 || event.eventType === 'Virtual')">
                  <div
                    v-bind:class="{'event-odds-cell-wrapper--disabled': (marketsGroupedByEvents[event.id].mainMarket !=='undefined' && marketsGroupedByEvents[event.id].mainMarket.status !== 'ACTIVE')||(!backendConnectionEstablished)|| (!appIsOnline || isInLockdown) || (!feedMap[event.feed])}"
                    class="event-odds-cell-wrapper">
                    <div class="event-odds-cell-overlay-text-wrapper"
                         v-if="(typeof marketsGroupedByEvents[event.id].mainMarket !=='undefined' && marketsGroupedByEvents[event.id].mainMarket.status === 'INACTIVE')  || (!appIsOnline || isInLockdown)  || (!backendConnectionEstablished) || (!feedMap[event.feed])">
                      <div class="overlay-text inactive-text">
                        {{$t('overlays.inactive') | removeDiacriticsFromUppercase}}
                      </div>
                    </div>
                    <div class="event-odds-cell-overlay-text-wrapper"
                         v-if="(typeof marketsGroupedByEvents[event.id].mainMarket !=='undefined' && marketsGroupedByEvents[event.id].mainMarket.status === 'SUSPENDED' && (appIsOnline && !isInLockdown)  && (backendConnectionEstablished)  && (feedMap[event.feed]))">
                      <div class="overlay-text suspended-text">
                        {{$t('overlays.suspended') | removeDiacriticsFromUppercase}}
                      </div>
                    </div>
                    <v-col
                      v-for="runner in marketsGroupedByEvents[event.id].mainMarket.runners"
                      v-bind:key="runner.id"
                      v-bind:class="{
                          'event-odds-cell-single': marketsGroupedByEvents[event.id].mainMarket.runners.length === 1,
                          'event-odds-cell-double': marketsGroupedByEvents[event.id].mainMarket.runners.length === 2,
                          'event-odds-cell-triple': marketsGroupedByEvents[event.id].mainMarket.runners.length === 3,
                          'event-odds-cell-wrapper--disabled': runner.active === false && typeof marketsGroupedByEvents[event.id].mainMarket !== 'undefined' && marketsGroupedByEvents[event.id].mainMarket.status === 'ACTIVE' && (appIsOnline && !isInLockdown)  && (backendConnectionEstablished)  && (feedMap[event.feed])
                       }"
                      class="bordered-event-cell event-odds-cell top-border-event-cell">
                      <!-- col="1" -->
                      <div class="event-odds-cell-overlay-text-wrapper"
                           v-if="runner.active === false && typeof marketsGroupedByEvents[event.id].mainMarket !== 'undefined' && marketsGroupedByEvents[event.id].mainMarket.status === 'ACTIVE' && (appIsOnline && !isInLockdown)  && (backendConnectionEstablished)  && (feedMap[event.feed])">
                        <div class="runner-overlay-text inactive-text">
                          {{$t('overlays.inactive') | removeDiacriticsFromUppercase}}
                        </div>
                      </div>

                      <div class="odds-wrapper">

                        <span class="odds-team-text">{{runner.name}}</span>
                        <!-- old layout start
                        <div class="break"></div>
                        <kryptButton color="superman" displayedText=" 1.72">
                          1.72
                        </kryptButton>
                        <kryptButton color="lex-luthor" displayedText=" 1.72">
                          1.72
                        </kryptButton>
                        <div class="break"></div>

                      <span class="odds-subtext">1666$</span>
                      <span class="odds-subtext">1666$</span>
                      old layout end -->
                        <v-row class="ma-0 justify-center">
                          <v-col
                            class="pa-0 mr-1 d-flex flex-column align-end justify-start calc-width">
                            <kryptButton color="superman"
                                         @click.native="addBetEntry(runner.id,runner.layOdds && runner.layOdds.length != 0 && Math.trunc(runner.layOdds[0].stake) !== 0? runner.layOdds[0].odds: '',
                                         'back',
                                         (typeof marketsGroupedByEvents[event.id].mainMarket !=='undefined'?marketsGroupedByEvents[event.id].mainMarket:'~'),
                                         runner.name,
                                         event)"
                                         :betInfo="{runnerId:runner.id, displayedText:(runner.layOdds && runner.layOdds.length != 0 && Math.trunc(runner.layOdds[0].stake) !== 0? runner.layOdds[0].odds: '&mdash;')}"
                                         :displayedText="runner.layOdds && runner.layOdds.length != 0 && Math.trunc(runner.layOdds[0].stake) !== 0? runner.layOdds[0].odds: '&mdash;'">

                            </kryptButton>
                            <div class="odds-subtext">
                              {{$store.state.userCurrency}}{{runner.layOdds && runner.layOdds.length
                              != 0?
                              Math.trunc(runner.layOdds[0].stake) : 0}}
                            </div>
                          </v-col>
                          <v-col
                            class="pa-0 d-flex flex-column align-start justify-start calc-width">
                            <kryptButton color="lex-luthor"
                                         @click.native="addBetEntry(runner.id,runner.backOdds && runner.backOdds.length != 0 && Math.trunc(runner.backOdds[0].stake) !== 0? runner.backOdds[0].odds: '',
                                         'lay',
                                         (typeof marketsGroupedByEvents[event.id].mainMarket !=='undefined'?marketsGroupedByEvents[event.id].mainMarket:'~'),
                                         runner.name,
                                         event)"
                                         :betInfo="{runnerId:runner.id, displayedText:(runner.backOdds && runner.backOdds.length != 0 && Math.trunc(runner.backOdds[0].stake) !== 0? runner.backOdds[0].odds: '&mdash;')}"
                                         :displayedText="runner.backOdds && runner.backOdds.length != 0 && Math.trunc(runner.backOdds[0].stake) !== 0? runner.backOdds[0].odds: '&mdash;'">

                            </kryptButton>
                            <div class="odds-subtext">
                              {{$store.state.userCurrency}}{{runner.backOdds &&
                              runner.backOdds.length != 0 ?
                              Math.trunc(runner.backOdds[0].stake) : '0'}}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </div>
                </template>


                <v-col
                  v-if="marketsGroupedByEvents[event.id] &&
                 (typeof marketsGroupedByEvents[event.id].mainMarket === 'undefined'||(marketsGroupedByEvents[event.id].mainMarket.isDummyMainMarket === true) || marketsGroupedByEvents[event.id].mainMarket.runners.length >3 || event.eventType === 'Virtual')"
                  class=" view-markets-cell top-border-event-cell event-odds-cell-single ">
                  <!-- col="1" -->
                  <v-row class="ma-0 view-markets-row">
                    <div class="view-markets-button d-flex flex-row justify-center"
                         @click="selectEvent(event)">
                      <v-icon
                        size="24"
                        class="more-games-icon"
                        color="#727779"
                      >
                        krypt-more-horizontal

                      </v-icon>
                      <span class="view-markets-text">{{$t('eventsList.viewMarkets') | removeDiacriticsFromUppercase}}</span>
                    </div>
                  </v-row>
                </v-col>
              </template>


            </v-row>

          </v-container>
          <v-footer padless class="more-games"
                    @click.native="selectTournament(tournament.tournament)"
                    v-if="tournament.events.length > 4 && selectedTournament === 'none'"
          >
            <!-- not needed
            <div class="float-right more-games" :ripple="false"

            > -->
            <v-icon
              size="24"
              class="more-games-icon"
              color="#A0A3A5"
            >
              krypt-more-horizontal
            </v-icon>
            <span class="more-games-text">{{ $t('eventsList.allEvents') | removeDiacriticsFromUppercase}}</span>
            <!-- </div> -->
          </v-footer>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <EmptyPage v-show="activeListIsEmpty || emptyPageBypass === true"></EmptyPage>

  </div>

</template>

<script>
import LiveLabel from '@/components/other/kryptLiveLabel.vue';
import kryptButton from '@/components/other/kryptButton.vue';
import LiveLabelIcon from '@/assets/utility/Live Tag.svg';
import EmptyPage from '@/components/EmptyPage';

const LiveTagObj = new Image();
LiveTagObj.src = LiveLabelIcon;

export default {
  name: 'EventsList',
  data: function () {
    return {
      emptyPageBypass: false,
      activePanels: [0, 1, 2, 3, 4],
      LiveLabelIcon: LiveLabelIcon,
      statusIdsForClock: [6, 7, 41, 42, 1, 2, 13, 14, 15, 16, 40],
      shouldReCalculateActiveList: Date.now(),
      shouldReCalculateActiveListTimer: {}
    };
  },
  watch: {
    selectedSport: function () {
      this.activePanels = this.activeEventsList.map((event, index) => index);
      this.scrollToTop();
    },
    selectedTournament: function () {
      this.activePanels = this.activeEventsList.map((event, index) => index);
      this.scrollToTop();
    },
    selectedCategory: function () {
      this.activePanels = this.activeEventsList.map((event, index) => index);
      this.scrollToTop();
    },
    selectedTimeframe: function () {
      this.activePanels = this.activeEventsList.map((event, index) => index);
      this.scrollToTop();
    },
    activeEventsList: function (newList, oldList) {
      if (oldList.length < newList.length) {
        for (let i in newList) {
          if (Number(i) > oldList.length - 1 && i < 4) {
            this.activePanels.push(Number(i));
          }
        }
      }

      // this.activePanels = this.activeEventsList.map((event, index) => index);
    }
  },
  components: {
    LiveLabel: LiveLabel,
    kryptButton: kryptButton,
    EmptyPage: EmptyPage

  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    addBetEntry: function (runnerId, odds, betType, market, runnerName, event) {
      let eventName = '~';
      if (event.eventType !== 'Virtual') {
        eventName = `${event.homeTeam} &ndash; ${event.awayTeam}`;
      } else {
        eventName = event.name;
      }
      let betId = window.uuidv4();

      this.$store.commit('addBet', {
        refId: betId,
        runnerId: runnerId,
        isValid: true,
        odds: odds.toString(),
        stake: '',
        keepBetOnLive: false,
        betType: betType,
        eventName: eventName,
        marketName: market.name,
        marketId: market.id,
        eventId: event.id,
        runnerName: runnerName,
      });

      this.$store.commit('setActiveBetSection', 'betslip');

    },
    selectEventForStreamOnly: function (event) {

      this.$store.commit('setLiveCenterEvent', event);
      this.$store.commit('setLiveCenterActiveSection', 'video');
      if (this.streamMappings.hasOwnProperty(event.remoteId) && this.streamMappings[event.remoteId].streams !== '') {
        this.$store.dispatch('getValidStreamInfo', {
          rid: event.remoteId,
          streamId: this.streamMappings[event.remoteId].streams,
          event: event
        });
      }
    },
    selectEventForLiveCenterOnly: function (event) {
      this.$store.commit('setLiveCenterActiveSection', 'lmt');
      this.$store.commit('setLiveCenterEvent', event);
    },
    selectEventForLiveCenter: function (event) {
      if (this.isMobileOrTablet) {
        this.selectEventForEventPage(event);
      }
      this.$store.commit('setLiveCenterActiveSection', 'lmt');
      this.$store.commit('setLiveCenterEvent', event);
    },
    selectEventForStream: function (event) {
      if (this.isMobileOrTablet) {
        this.selectEventForEventPage(event);
      }
      if (this.streamMappings.hasOwnProperty(event.remoteId) && this.streamMappings[event.remoteId].streams !== '') {

        this.selectEventForStreamOnly(event);
      }
    },
    selectEventForLiveCenterAndEventPage: function (event) {
      if (this.isMobileOrTablet) {
        this.selectEvent(event);
      }
      this.$store.commit('setLiveCenterEvent', event);
      this.$store.commit('setLiveCenterActiveSection', 'video');
      if (this.streamMappings.hasOwnProperty(event.remoteId) && this.streamMappings[event.remoteId].streams !== '') {
        this.$store.dispatch('getValidStreamInfo', {
          rid: event.remoteId,
          streamId: this.streamMappings[event.remoteId].streams,
          event: event
        });
      }

    },
    shouldShowInGameClock: function (event) {
      return this.statusIdsForClock.includes(event.matchStatus?.statusId) && typeof event.matchStatus?.eventClock !== 'undefined';

    },
    togglePanel: function (index, event) {

      if (typeof this.activePanels.find(element => element === index) !== 'undefined') {
        this.activePanels.splice(this.activePanels.indexOf(index), 1,);
      } else {
        this.activePanels.push(index);
      }

    },
    processTimeCellInfo: function (event) {
      let timeCellContent = `&#128580;`; /* added some humour compared to previous `~~~` */
      if ((event.status === 'Not_Started' || event.status === 'MatchAboutToStart' || (event.status === 'Postponed' && this.moment()
          .isBefore(this.moment(event.start)
            .local())))
        && event.eventType !== 'Virtual') { //&& this.marketsGroupedByEvents[event.id].hasOneActiveMarket === true) {
        timeCellContent = this.showProcessedDateInformation(event.start);

      }
      // else if (this.marketsGroupedByEvents[event.id] && this.marketsGroupedByEvents[event.id].hasOneActiveMarket === false && !(event.status === 'Live'
      //   && event.status === 'Suspended'
      //   && event.status === 'Abandoned'
      //   && event.status === 'Interrupted'
      //  ))
      // {
      //   timeCellContent = `${this.$i18n.t('eventsList.closed')}`;
      //
      // }

      // *** cancelled the closed state for non-outrights events ***
      // else if (this.marketsGroupedByEvents[event.id].hasOneActiveMarket === false && !(event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended')) {
      //  timeCellContent = `${this.$i18n.t('eventsList.closed')}`;
      //}

      else if (event.status === 'Delayed' && event.eventType !== 'Virtual') { // && this.marketsGroupedByEvents[event.id].hasOneActiveMarket === true) {
        timeCellContent = `${this.$i18n.t('eventsList.delayed')}`;

      } else if (event.status === 'Postponed'
          && (this.moment().isAfter(this.moment(event.start).local()) || event.start == null)
          && event.eventType !== 'Virtual') { // && this.marketsGroupedByEvents[event.id].hasOneActiveMarket === true) {
        timeCellContent = `${this.$i18n.t('eventsList.postponed')}`;

      } else if (event.status === 'Cancelled') { // && this.marketsGroupedByEvents[event.id].hasOneActiveMarket === true) {
        timeCellContent = `${this.$i18n.t('eventsList.cancelled')}`;

      } else if (event.status === 'Abandoned' && event.eventType !== 'Virtual') {
        timeCellContent = `${this.$i18n.t('eventsList.abandoned')}`;

      } else if (event.status === 'Live' && event.eventType !== 'Virtual') {
        timeCellContent = `${event.matchStatus?event.matchStatus.status:''}${this.shouldShowInGameClock(event) ? ` ${event.matchStatus?.eventClock?.eventTime}'` : ''}`;
      } else if (event.status === 'Suspended' && event.eventType !== 'Virtual') {
        timeCellContent = `${this.$i18n.t('eventsList.suspended')}`;
      } else if (event.status === 'Interrupted' && event.eventType !== 'Virtual') {
        timeCellContent = `${this.$i18n.t('eventsList.interrupted')}`;
      } else if (event.status === 'Ended') {
        timeCellContent = `${this.$i18n.t('eventsList.ended')}`;

      } else if (event.eventType === 'Virtual') { // && this.marketsGroupedByEvents[event.id].hasOneActiveMarket === true) {
        timeCellContent = `<span style="margin-bottom:2px;">${this.$i18n.t('eventsList.ends')}</span>
        ${new Intl.DateTimeFormat(window.SelectedTimeLocalisation, {
          month: 'short',
          day: 'numeric'
        }).format(this.moment.utc(event.end)
          .local())}`;

      }
      // *** cancelled closed state for outrights events ***
      //  else if (event.eventType === 'Virtual' && this.marketsGroupedByEvents[event.id].hasOneActiveMarket === false) {
      //  timeCellContent = `${this.$i18n.t('eventsList.closed')}`;
      //}
      return timeCellContent;
    },
    getCurrDayAndMonth: function (locale) {
      var today = locale.format('ll');
      return today
        .replace(locale.format('YYYY'), '') // remove year
        .replace(/\s\s+/g, ' ')// remove double spaces, if any
        .trim() // remove spaces from the start and the end
        .replace(/[рг]\./, '') // remove year letter from RU/UK locales
        .replace(/de$/, '') // remove year prefix from PT
        .replace(/b\.$/, '') // remove year prefix from SE
        .trim() // remove spaces from the start and the end
        .replace(/,$/g, ''); // remove comma from the end
    },
    showProcessedDateInformation: function (date) {
      let timeCellContent = `&#129300;`; /* added some humour compared to previous `---` */
      if (!this.moment()
        .isSame(this.moment.utc(date)
          .local(), 'day')) {
        timeCellContent = `<span style="margin-bottom:2px;">${new Intl.DateTimeFormat(window.SelectedTimeLocalisation, {
          month: 'short',
          day: 'numeric'
        }).format(this.moment.utc(date)
          .local())}</span>${this.moment.utc(date)
          .local()
          .format('HH:mm')}`;
      } else if (this.moment.utc(date)
        .diff(this.moment()
          .utc(), 'minutes') >= 15) {
        timeCellContent = `<span style="margin-bottom:2px;">${this.$i18n.t('eventsList.today')}</span>${this.moment.utc(date)
          .local()
          .format('HH:mm')}`;
      } else if (
        this.moment.utc(date)
          .diff(this.moment()
            .utc(), 'minutes', true) >= 0 && this.moment.utc(date)
          .diff(this.moment()
            .utc(), 'minutes') < 15) {
        timeCellContent = `<span style="line-height: 18px;">${this.$i18n.t('eventsList.startingIn')} ${this.moment.utc(date)
          .add(1, 'minutes')
          .diff(this.moment()
            .utc(), 'minutes')}'</span>`;
      } else if (this.moment.utc(date)
        .diff(this.moment()
          .utc(), 'minutes', true) < 0) {
        timeCellContent = `<span > ${this.$i18n.t('eventsList.delayed')}</span>`;
      }

      return timeCellContent;
    },
    selectTournament: function (tournament) {
      if (this.selectedSport === 'none') {
        this.sports.forEach((sport) => {
          if (sport.name === tournament.sport) {
            this.$store.dispatch('selectSportAndResetEvent', sport);
          }
        });
      }

      if (this.nonDesktopMode) {
        this.$store.commit('setSelectedEvent', 'none');
        this.$store.commit('setSelectedTournament', tournament);
      } else {
        this.$store.commit('setSelectedTournament', tournament
        );
      }
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    selectEventForEventPage: function (event) {
      this.$store.commit('setSelectedEvent', event);
      if(this.isTrader){
        this.$store.dispatch('getSupportedMarketsForTournament',event.tournamentId)
      }
      if (this.isMobileOrTablet) {
        this.selectEventForLiveCenterOnly(event);
      }
      if (typeof event !== 'undefined' && (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended')) {
        this.selectEventForLiveCenterOnly(event);
      }
      this.$store.commit('setHasData');
      if (event.eventType !== 'Virtual' && this.streamMappings.hasOwnProperty(event.remoteId) && this.streamMappings[event.remoteId].streams !== '' && event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended') {
        this.$store.dispatch('getValidStreamInfo', {
          rid: event.remoteId,
          streamId: this.streamMappings[event.remoteId].streams,
          event: event
        });
      }
    },
    selectEvent: function (event) {
      if (this.isMobileOrTablet) {
        this.selectEventForLiveCenterOnly(event);
        this.selectEventForEventPage(event);

      } else {
        this.selectEventForEventPage(event);
      }
    },
    calculateEventsList: function (eventsArray, fallBackToVirtual) {
      let calculatedArray = [];
      calculatedArray = eventsArray.filter(function (event) {
        return typeof this.marketsGroupedByEvents[event.id] !== 'undefined'
          // && (this.marketsGroupedByEvents[event.id].hasOneActiveMarket || (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended'))
          && event.eventType !== 'Virtual'
          && ((this.selectedTimeframe === 'today' && this.moment.utc(event.start)
              .local()
              .isSame(this.moment()
                .local(), 'day'))
            || (this.selectedTimeframe === 'tomorrow' && this.moment.utc(event.start)
              .local()
              .isSame(this.moment()
                .add(1, 'days')
                .local(), 'day'))
            || (this.selectedTimeframe === 'future' && this.moment.utc(event.start)
              .local()
              .isAfter(this.moment()
                .add(1, 'days')
                .local(), 'day'))
            || ((this.selectedTimeframe === 'inPlay' && (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended')))
            || this.selectedTimeframe === 'all')
          ;
      }.bind(this))
        .sort(function (a, b) {
          if (a.start < b.start) {
            return -1;
          }
          if (a.start > b.start) {
            return 1;
          }
          return 0;
        });
      if (calculatedArray.length === 0 && fallBackToVirtual === true) {
        calculatedArray = eventsArray.filter(function (event) {
          return typeof this.marketsGroupedByEvents[event.id] !== 'undefined'
            // && (this.marketsGroupedByEvents[event.id].hasOneActiveMarket || (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended'))
            && ((this.selectedTimeframe === 'today' && this.moment.utc(event.end)
                .local()
                .isSameOrAfter(this.moment()
                  .local(), 'day'))
              || (this.selectedTimeframe === 'tomorrow' && this.moment.utc(event.end)
                .local()
                .isSameOrAfter(this.moment()
                  .add(1, 'days')
                  .local(), 'day'))
              || (this.selectedTimeframe === 'future' && this.moment.utc(event.end)
                .local()
                .isAfter(this.moment()
                  .add(1, 'days')
                  .local(), 'day'))
              || this.selectedTimeframe === 'all')
            ;
        }.bind(this))
          .sort(function (a, b) {
            if (a.start < b.start) {
              return -1;
            }
            if (a.start > b.start) {
              return 1;
            }
            return 0;
          });
      }

      return calculatedArray;
    },
    calculateEventsListOnlyVirtual: function (eventsArray) {
      let calculatedArray = [];

      calculatedArray = eventsArray.filter(function (event) {
        return typeof this.marketsGroupedByEvents[event.id] !== 'undefined'
          // && (this.marketsGroupedByEvents[event.id].hasOneActiveMarket || (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended'))
          && event.eventType === 'Virtual'
          && ((this.selectedTimeframe === 'today' && this.moment.utc(event.end)
              .local()
              .isSameOrAfter(this.moment()
                .local(), 'day'))
            || (this.selectedTimeframe === 'tomorrow' && this.moment.utc(event.end)
              .local()
              .isSameOrAfter(this.moment()
                .add(1, 'days')
                .local(), 'day'))
            || (this.selectedTimeframe === 'future' && this.moment.utc(event.end)
              .local()
              .isAfter(this.moment()
                .add(1, 'days')
                .local(), 'day'))
            || this.selectedTimeframe === 'all'
          );
      }.bind(this))
        .sort(function (a, b) {
          if (a.start < b.start) {
            return -1;
          }
          if (a.start > b.start) {
            return 1;
          }
          return 0;
        });
      return calculatedArray;

    }
  },
  mounted: function () {
    this.shouldReCalculateActiveListTimer = setTimeout(function () {
      this.shouldReCalculateActiveList = Date.now();
    }.bind(this), 60000);
    window.EventsList = this;
  },
  computed: {
    isTrader:function(){
      return this.$store.state.user.isTrader;
    },
    eventsWithBets: function () {
      return this.$store.state.bets.active.eventsWithBets;
    },
    isLoggedIn: function () {
      return this.$store.state.user.isLoggedIn;
    },
    isMobileOrTablet: function () {
      return (this.$store.state.deviceMode === 'mobile-landscape' || this.$store.state.deviceMode === 'mobile-portrait' || this.$store.state.deviceMode === 'tablet');

    },
    streamMappings: function () {
      return this.$store.state.streamMappingsObj;
    },
    appIsOnline: function () {
      return this.$store.state.appIsOnline;
    },

    isInLockdown: function () {
      return this.$store.state.isInLockdown;
    },
    feedIsOnline: function () {
      return this.$store.state.feedIsOnline;
    },
    feedMap: function () {
      return this.$store.state.feedStatus.list.reduce((list, feed) => {
        return {
          ...list,
          [feed['feed']]: feed.healthy,
        };
      }, {})
      // return this.$store.state.feedStatus.reduce((list, feed) => (list[feed.feed] = feed.healthy), {})
    },
    backendConnectionEstablished: function () {
      return this.$store.state.backendConnectionEstablished;
    },
    activeListIsEmpty: function () {
      return this.activeEventsList.length === 0 || this.activeEventsList.filter((tournament) => {
        return tournament.events.length > 0;
      }).length === 0;
    },

    nonDesktopMode: function () {
      return (this.$store.state.deviceMode !== 'desktop');
    },
    selectedTimeframe: function () {
      return this.$store.state.navigations.timeframe;
    },
    selectedSport: function () {
      return this.$store.state.navigations.selectedSport;
    },
    marketsGroupedByEvents: function () {
      return this.$store.state.markets;
    },
    isMobile: function () {
      return (this.$store.state.deviceMode === 'mobile-landscape' || this.$store.state.deviceMode === 'mobile-portrait');
    },
    eventsList: function () {
      return this.$store.state.events.eventsList;
    },
    sports: function () {
      return this.$store.state.navigations.sports;
    },
    selectedCategory: function () {
      return this.$store.state.navigations.selectedCategory;
    },
    popularSport: function () {
      return this.$store.state.navigations.sports[0];
    },
    sportData: function () {
      return this.$store.state.navigations.selectedSportData;
    },
    allSports: function () {
      return this.$store.state.navigations.sports;
    },
    totalEvents: function () {
      return this.$store.state.events.eventsList.totalEvents;
    },
    allSportsCompetitionsWithoutPopularSport: function () {
      let competitionsArray = [];
      this.allSports.slice(1)
        .forEach((sport) => competitionsArray = competitionsArray.concat(sport.tournaments));
      return competitionsArray;
    },
    marketList: function () {
      return this.$store.state.markets;
    },
    tournamentsGroupedByCategory: function () {
      let groupedTournaments = {};
      this.sportData.categories.forEach((category) => {
        groupedTournaments[category.id] = [];
      });
      this.sportData.tournaments.forEach((tournament) => {
          groupedTournaments[tournament.categoryId].push(tournament);
        }
      );
      return groupedTournaments;

    },
    selectedEvent: function (event) {
      return this.$store.state.navigations.selectedEvent;
    },
    initialStateReady: function () {
      return this.$store.state.initialStateReady;
    },
    activeEventsList: function () {

      if (this.initialStateReady) {
        window.activeListCounter++;
        // console.log(window.activeListCounter)
        let activeCompetitionsList = [];
        if (this.shouldReCalculateActiveList) {
          activeCompetitionsList = [];
        }
        clearTimeout(this.shouldReCalculateActiveListTimer);
        this.shouldReCalculateActiveListTimer = setTimeout(function () {
          this.shouldReCalculateActiveList = Date.now();
        }.bind(this), 60000);

        if (this.selectedTournament !== 'none' && typeof this.eventsList[this.selectedTournament.id]) {
          if (this.selectedTimeframe === 'all' || this.selectedTimeframe === 'inPlay') {
            activeCompetitionsList.push({
              title: this.$i18n.t('eventsList.inPlay'),
              events: (typeof this.eventsList[this.selectedTournament.id] !== 'undefined' ? Object.values(this.eventsList[this.selectedTournament.id]) : [])
                .filter(function (event) {
                  return typeof this.marketsGroupedByEvents[event.id] !== 'undefined'
                    && event.eventType !== 'Virtual'
                    && (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended')
                    ;
                }.bind(this))
                .sort(function (a, b) {
                  if (a.start < b.start) {
                    return -1;
                  }
                  if (a.start > b.start) {
                    return 1;
                  }
                  return 0;
                })
            });
          }
          if (this.selectedTimeframe === 'all' || this.selectedTimeframe !== 'inPlay') {
            activeCompetitionsList.push({
              title: this.$i18n.t('eventsList.comingUp'),
              events: (typeof this.eventsList[this.selectedTournament.id] !== 'undefined' ? Object.values(this.eventsList[this.selectedTournament.id]) : [])
                .filter(function (event) {
                  return typeof this.marketsGroupedByEvents[event.id] !== 'undefined'
                    // && this.marketsGroupedByEvents[event.id].hasOneActiveMarket
                    && event.eventType !== 'Virtual'
                    && !(event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended')
                    && ((this.selectedTimeframe === 'today' && this.moment.utc(event.start)
                        .local()
                        .isSame(this.moment()
                          .local(), 'day'))
                      || (this.selectedTimeframe === 'tomorrow' && this.moment.utc(event.start)
                        .local()
                        .isSame(this.moment()
                          .add(1, 'days')
                          .local(), 'day'))
                      || (this.selectedTimeframe === 'future' && this.moment.utc(event.start)
                        .local()
                        .isAfter(this.moment()
                          .add(1, 'days')
                          .local(), 'day'))
                      || this.selectedTimeframe === 'all'
                    )
                    ;
                }.bind(this))
                .sort(function (a, b) {
                  if (a.start < b.start) {
                    return -1;
                  }
                  if (a.start > b.start) {
                    return 1;
                  }
                  return 0;
                })
                .slice(0, 25)
            });

          }
          if (this.selectedTimeframe !== 'inPlay') {
            activeCompetitionsList.push({
              title: this.$i18n.t('eventsList.longTerm'),
              events: (typeof this.eventsList[this.selectedTournament.id] !== 'undefined' ? Object.values(this.eventsList[this.selectedTournament.id]) : [])
                .filter(function (event) {
                  return typeof this.marketsGroupedByEvents[event.id] !== 'undefined'
                    // && this.marketsGroupedByEvents[event.id].hasOneActiveMarket
                    && event.eventType === 'Virtual'
                    && ((this.selectedTimeframe === 'today' && this.moment.utc(event.end)
                        .local()
                        .isSameOrAfter(this.moment()
                          .local(), 'day'))
                      || (this.selectedTimeframe === 'tomorrow' && this.moment.utc(event.end)
                        .local()
                        .isSameOrAfter(this.moment()
                          .add(1, 'days')
                          .local(), 'day'))
                      || (this.selectedTimeframe === 'future' && this.moment.utc(event.end)
                        .local()
                        .isAfter(this.moment()
                          .add(1, 'days')
                          .local(), 'day'))
                      || this.selectedTimeframe === 'all'
                    )
                    ;
                }.bind(this))
                .sort(function (a, b) {
                  if (a.start < b.start) {
                    return -1;
                  }
                  if (a.start > b.start) {
                    return 1;
                  }
                  return 0;
                })
            });

          }

        } else if (this.selectedCategory !== 'none') {
          for (let i in this.tournamentsGroupedByCategory[this.selectedCategory.id]) {
            let current = this.tournamentsGroupedByCategory[this.selectedCategory.id][i];
            let objectToPush = {
              tournament: current,
              events: (typeof this.eventsList[current.id] !== 'undefined' ? this.calculateEventsList(Object.values(this.eventsList[current.id])) : [])
            };
            if (this.selectedTimeframe !== 'inPlay') {
              objectToPush.events = objectToPush.events.slice(0, 5);
            }
            if (objectToPush.events.length > 0) activeCompetitionsList.push(objectToPush);
          }
          if (activeCompetitionsList.length === 0) {
            for (let i in this.tournamentsGroupedByCategory[this.selectedCategory.id]) {
              let current = this.tournamentsGroupedByCategory[this.selectedCategory.id][i];
              activeCompetitionsList.push({
                tournament: current,
                events: (typeof this.eventsList[current.id] !== 'undefined' ? this.calculateEventsListOnlyVirtual(Object.values(this.eventsList[current.id])) : []).slice(0, 5)

              });
            }
          }
          // If all is empty check for outrights and allow them

        } else if (this.selectedSport !== 'none' && this.sportData && this.sportData.tournaments) {
          activeCompetitionsList = this.sportData.tournaments.map(function (currentTournament) {
            let eventsToReturn = [];
            if (typeof this.eventsList[currentTournament.id] !== 'undefined') {
              eventsToReturn = this.calculateEventsList(Object.values(this.eventsList[currentTournament.id]));
            }
            return {
              tournament: currentTournament,
              events: (this.selectedTimeframe !== 'inPlay' ? eventsToReturn.slice(0, 5) : eventsToReturn)
            };
          }.bind(this))
            .filter((tournament) => {
              return tournament.events.length > 0;
            });
          /* Slicing of the number of competitions we will have in the events list happens HERE*/
          /*if (this.selectedTimeframe !== 'inPlay') {
            activeCompetitionsList = activeCompetitionsList.slice(0, 10);
          }*/
          activeCompetitionsList = activeCompetitionsList.slice(0, 10);
          // If all is empty check for outrights and allow them
          if (activeCompetitionsList.length === 0) {
            let virtualActiveCompetitionsList;
            virtualActiveCompetitionsList = this.sportData.tournaments.map(function (currentTournament) {
              return {
                tournament: currentTournament,
                events: (typeof this.eventsList[currentTournament.id] !== 'undefined' ? this.calculateEventsListOnlyVirtual(Object.values(this.eventsList[currentTournament.id])) : []).slice(0, 5)
              };
            }.bind(this))
              .filter((tournament) => {
                return tournament.events.length > 0;
              })
              .slice(0, 5);

            activeCompetitionsList = virtualActiveCompetitionsList.slice(0, 5);
          }

        } else if (this.selectedSport === 'none' && this.popularSport && this.popularSport.tournaments && this.totalEvents > 0) {
          // activeCompetitionsList = this.popularSport.tournaments.slice(0,5).map(function(currentTournament){
          //   return  {tournament:currentTournament,events:Object.values(this.eventsList[currentTournament.id]).slice(0, 5)}
          // }.bind(this))
          activeCompetitionsList = this.popularSport.tournaments.map(function (currentTournament) {
            let eventsList = [];
            eventsList = (typeof this.eventsList[currentTournament.id] !== 'undefined' ?
              this.calculateEventsList(Object.values(this.eventsList[currentTournament.id])) : [])
              .slice(0, 5);
            return {
              tournament: currentTournament,
              events: eventsList
            };
          }.bind(this))
            .filter((tournament) => {
              return tournament.events.length > 0;
            })
            .slice(0, 5);
          if (activeCompetitionsList.length < 5) {
            for (let counter in this.allSportsCompetitionsWithoutPopularSport) {
              if (typeof this.eventsList[this.allSportsCompetitionsWithoutPopularSport[counter].id] !== 'undefined') {
                let currentCompetition = {};
                let notPopularSportCompetition = true;

                //Calculate the events filtered and sorted and sliced
                let eventsToPush = this.calculateEventsList(Object.values(this.eventsList[this.allSportsCompetitionsWithoutPopularSport[counter].id]))
                  .slice(0, 5);
                if (eventsToPush.length > 0) {
                  currentCompetition = {
                    tournament: this.allSportsCompetitionsWithoutPopularSport[counter],
                    events: eventsToPush
                  };

                }
                //Check to see if the competition's sport matches one of the popular competitions' sport
                for (let j in activeCompetitionsList) {
                  if (
                    typeof activeCompetitionsList[j].tournament !== 'undefined' && typeof this.allSportsCompetitionsWithoutPopularSport[counter] !== 'undefined' &&
                    activeCompetitionsList[j].tournament.sport === this.allSportsCompetitionsWithoutPopularSport[counter].sport
                  ) {
                    // Its matched so flag it so to not push later and stop the checking procedure
                    notPopularSportCompetition = false;
                    break;
                  }
                }
                if (notPopularSportCompetition && eventsToPush.length > 0) activeCompetitionsList.push(currentCompetition);
                //If we have 5 competitions stop
                if (activeCompetitionsList.length === 5) break;
              }

            }
          }
          //If the list is empty check for virtual event for events
        }
        return activeCompetitionsList;
      } else {
        return [];
      }

    },
    selectedTournament: function () {
      return this.$store.state.navigations.selectedTournament;
    }

  }
};
</script>

<style scoped>
  .overlay-text {
    position: absolute;
    top: 50%;
    left: 50%;
    right: calc(-50% + 16px);
    text-transform: uppercase;
    transform: translate(-50%, -50%);
  }

  .runner-overlay-text {
    position: absolute;
    top: 50%;
    text-transform: uppercase;
    left: 50%;
    right: calc(-50% + 16px);
    transform: translate(-50%, -50%);
  }

  .teams-wrapper {
    /* max-width: 100%; - changed max-width to width because for very short team names,
    despite the available space, names were cut off for short combinations like "Ρεν - Τσέλσι" */
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .score-wrapper {
    text-align: right;
    margin-right: 16px;
  }

  .event-info-wrapper {
    display: flex;
    flex-direction: row;
  }

  .view-markets-cell {
    padding: 8px; /* applicable for mobile - see media query for desktop version */
    min-width: 200px; /* most probably not required but doesn't hurt */
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex-basis: unset;
    flex-grow: unset;
  }

  .view-markets-text {
    font-style: normal;
    /* not required - width: 131px;*/
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 8px;
    margin-bottom: 8px;
    color: #727779;
  }

  .view-markets-button {
    margin: 0px;
    background: #F4F5F7;
    border-radius: 6px;
    max-width: 184px;
    width: 184px;
    padding: 0px 8px 0px 8px;
    cursor: pointer;
  }

  .view-markets-button:hover {
    background: #e4e4e4;
  }

  .view-markets-button .more-games-icon.v-icon {
    margin-top: 8px;
    margin-bottom: 8px;
    margin-right: 2px;
    margin-left: 0px;
  }

  >>> .v-icon.krypt.krypt-arrow-down.theme--light {
    color: #0C1016;
  }

  .event-information-cell {
    cursor: pointer;
  }

  .match-info-icon {
    margin-left: 8px;
    height: min-content;
    line-height: 16px;
  }

  .match-info-icon:hover .v-icon:not(.krypt-live) {
    color: var(--grey-600) !important;
  }

  .match-info-icon .v-icon:not(.krypt-live) {
    cursor: pointer;
  }

  .match-info-icon .theme--light.v-icon:focus::after {
    opacity: 0;
  }

  .matched-text {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #5C5F61;
  }

  .matched-value {
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    margin-right: 8px;
    color: #B35C00;

  }

  .markets-text {
    font-size: 12px;
    font-weight: 400;
    color: #5C5F61;
    line-height: 16px;
  }

  .matched-content {
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  .odds-subtext {
    font-size: 12px;
    line-height: 16px;
    color: #727779;
    width: 100%;
    text-align: center;
    max-width: 61px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .event-odds-cell-wrapper {
    display: flex;
    position: relative;
  }

  .event-odds-cell-wrapper--disabled > .bordered-event-cell > * {
    opacity: 0.2;
  }

  .event-odds-cell-wrapper--disabled > .odds-wrapper > * {
    opacity: 0.2;
  }

  .event-odds-cell-overlay-text-wrapper {
    background: transparent;
    z-index: 2;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-weight: 700;
    text-align: center;
    line-height: 22px;
    overflow: hidden;
  }

  .inactive-text {
    color: #727779;

  }

  .suspended-text {
    color: #B35C00;
  }

  /* not required after using only left border
  .event-odds-cell-wrapper .bordered-event-cell:first-child {
    border-left: 1px solid #F4F5F7;
  }*/

  @media screen and (max-width: 883px) and (min-width: 310px) {
    /* changed max-width: 890 */
    .event-icons-cell {
      flex: 0 0 calc(45% - 64px) !important;
      max-width: calc(45% - 64px);
    }

    .event-odds-cell-wrapper > :not(.bordered-event-cell) + .bordered-event-cell{
      border-left: 0px solid #F4F5F7;
    }

    .event-odds-cell-wrapper {
      width: 100%;
    }

    /* moved to media query since this should happen for screen width <884px
    .event-odds-cell-wrapper .bordered-event-cell:first-child {
      border-left: 0px solid #F4F5F7;
    } */
    /* not required after putting all borders on the left side
    .event-odds-cell-wrapper > :not(.bordered-event-cell) + .bordered-event-cell{
      border-left: 0px solid #F4F5F7;
    } */
    /* removing because the margin between icons should always be 8px
    .match-info-icon, .user-bet-counter-back, .user-bet-counter-lay{
      margin-right: 4px!important;
    } */
  }

  @media screen and (max-width: 440px) {
    .odds-team-text {
      /* not needed - max-width: 94px; */

    }
  }

  @media screen and (max-width: 883px) {
    >>> .view-markets-row {
      justify-content: center;
    }

    .event-icons-cell {
      padding-right: 8px;
      padding-top: 8px;
      padding-bottom: 8px;
      align-items: flex-start;
    }

    .match-info-icon {
      /* not required, it's already inline-block - display: inline-block; */
      /* font-size: 20px !important; - deviating from spec because icons would be too small to tap */
    }

    /* not required since the 3rd child (icons container) doesn't have the bordered-event-cell class
    .bordered-event-cell:nth-child(3) {
      border-right: 0px solid #F4F5F7;
    } */
    .event-information-cell {
      padding: 8px;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      flex-basis: 55%; /* before - calc(62% - 64px); */
      max-width: 55%; /* before - calc(62% - 64px); */
    }


    .event-odds-cell {
      padding: 4px 4px 4px 4px;

    }

    .event-odds-cell-triple {
      width: 33.33%;

    }

    .event-odds-cell-double {
      width: 50%;

    }

    .event-odds-cell-single {
      width: 100%;

    }

    .odds-team-text {
      margin-bottom: 4px;
    }

    /* not needed
    .odds-subtext {
      width: 50%;
      padding: 2px 3px 4px 4px;
    } */
    .event-time-cell {
      padding-left: 2px;
      padding-right: 2px;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    .event-odds-cell-wrapper .bordered-event-cell:first-child {
      border-left: 0px solid #F4F5F7;
    }
  }

  @media screen and (min-width: 884px) {
    /* not needed
    .odds-subtext {
      padding: 0px 10px 0px 10px;
    } */
    /* the width is big and fixed, no matter the screen size
    .view-markets-button {
      width: 184px;
    } */
    /* no need for this, the text will be inside a flex container and will take as much space as necessary, it will even wrap
     .view-markets-text {
      width: 100%;
    } */
    .view-markets-cell {
      max-width: 200px;
      padding: 16px 16px 16px 0px;
    }

    .odds-team-text {
      margin-bottom: 8px;
    }

    .event-icons-cell {
      padding-right: 16px;
      padding-top: 16px;
      padding-bottom: 16px;
      align-items: center;
      max-width: 15%;
      min-width: 15%;

    }

    .matched-value {
      margin-right: 16px;
    }

    .event-information-cell {
      padding: 16px;
      flex-basis: unset;
      /* not required, creates problems on 4K screens - max-width: 900px !important; */
      width: calc(85% - 493px) !important;
    }

    .event-odds-cell {
      width: 143px; /* had to add 1 pixel since 1+8+61+4+61+8 = 143 */
      padding: 8px;

    }

    .event-time-cell {
      padding-left: 2px;
      padding-right: 2px;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }

  .more-games-icon {
    margin-top: 4px;
    margin-bottom: 4px;
    margin-right: 2px;
    margin-left: 0px;
  }

  .v-footer {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    color: #A0A3A5;
    background: #FFFFFF;
    border-top: 1px solid #F4F5F7;


  }

  .more-games-text {
    font-size: 10px;
    line-height: 14px;
    font-weight: 700;
    margin: 8px 0px;
    text-transform: uppercase;
    display: block;
    letter-spacing: 0.0892857143em;
  }

  .more-games:hover {
    color: #727779;
  }

  .more-games:hover i[style] {
    color: #727779 !important;
  }

  .more-games {

    padding: 0px 8px;
    flex-wrap: nowrap;
    cursor: pointer;
  }

  .odds-wrapper {
    text-align: center;
  }

  .user-bet-counter-lay {
    border-radius: 24px;
    background: #0462b9;
    color: white;
    margin-left: 8px;
    font-weight: bold;
    min-width: 23px;
    height: 20px;
    font-size: 12px;
    padding: 2px 8px 2px 8px;
    display: flex;
    line-height: 16px;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 2px;
    margin-bottom: 2px;
    /* cursor: pointer; - not yet because it doesn't have any functionality */
  }

  /* not yet because it doesn't have any functionality
  .user-bet-counter-lay:hover {
    background: #03529b;
  } */

  .user-bet-counter-back {
    border-radius: 24px;
    background: #E51245;
    color: white;
    margin-left: 8px;
    font-weight: bold;
    min-width: 23px;
    height: 20px;
    font-size: 12px;
    padding: 2px 8px 2px 8px;
    display: flex;
    line-height: 16px;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 2px;
    margin-bottom: 2px;
    /* cursor: pointer; - not yet because it doesn't have any functionality */
  }

  /* not yet because it doesn't have any functionality
  .user-bet-counter-back:hover {
    background: #d1103d;
  } */

  >>> .v-expansion-panel-content__wrap {
    padding: 0px;
  }

  .event-time-cell {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    max-width: 64px;
    min-width: 64px;
    color: #5C5F61;
    border-right: 1px solid #F4F5F7;
  }

  .event-icons-cell {
    display: flex;
    /* let it wrap, it's ok */
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .event-odds-cell {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    flex-basis: unset;
    flex-grow: unset;
    position: relative;

  }

  /*.event-time-cell>span,.event-time-cell>.live-label{*/
  /*  display: flex;*/
  /*  align-items: center;*/
  /*}*/
  .event-time-cell > span::before {
    content: "\A";
  }

  >>> .time-cell-text {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    flex-wrap: wrap;
    font-size: 12px;
    line-height: 16px;
    justify-content: flex-start;
    color: #5c5f61;
    overflow: hidden;
    width: 59px;
  }

  >>> .event-is-live .time-cell-text {
    color: #0c1016;
    margin-bottom: 8px;
    max-height: 35px;
  }

  .event-row {
    /*border: 1px solid #F4F5F6;*/
    /*border-spacing: 0px;*/
    /*border-collapse: collapse;*/
    /* killing the box-shadow
    box-shadow: 1px 0 0 0 #F4F5F6,
    0 1px 0 0 #F4F5F6,
    1px 1px 0 0 #F4F5F6, /* Just to fix the corner */
    /* 1px 0 0 0 #F4F5F6 inset,
       0 1px 0 0 #F4F5F6 inset; */
  }

  .v-expansion-panels {
    z-index: unset;
  }

  .v-expansion-panel {
    border-radius: 4px;
  }

  .v-expansion-panel-header {
    /* killing the box-shadow
    box-shadow: 1px 0 0 0 #F4F5F6,
    0 1px 0 0 #F4F5F6,
    1px 1px 0 0 #F4F5F6, /* Just to fix the corner */
    /* 1px 0 0 0 #F4F5F6 inset,
       0 1px 0 0 #F4F5F6 inset; */
    padding: 8px 8px 8px 16px;
    font-size: 12px;
    font-weight: 700;
    min-height: 32px;
    color: #0C1016;
    line-height: 16px;
  }

  .bordered-event-cell {
    border-left: 1px solid #F4F5F7;
  }

  /* not required, since the only border is now on the left side
  .bordered-event-cell:last-child {
    border-right: 0px solid #F4F5F7;
  } */

  .top-border-event-cell {
    border-top: 1px solid #F4f5f7;
  }

  .break {
    flex-basis: 100%;
    height: 0;
  }

  .container {
    padding: 0px;
    max-width: 100%;
    margin: 0px;
  }

  .team-info-text {
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 18px;
    display: block;
    color: #0C1016;
  }

  .score-text {
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    color: #0C1016;
  }

  .team-info-text::first-letter {
    text-transform: uppercase;
  }

  .top-margin-2 {
    margin-top: 2px;
  }

  .top-margin-3 {
    margin-top: 3px;
  }

  .odds-team-text {
    white-space: nowrap;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    /*max-width: 90px;*/
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    color: #5c5f61;
  }

  .odds-team-text::first-letter {
    text-transform: uppercase;
  }

  .odds-wrapper {
    width: 100%;
  }

  /* aligning footer with specs and killing vuetify box-shadow */
  .v-footer.v-sheet.theme--light.v-footer--padless {
    box-shadow: none;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .calc-width {
    max-width: calc(50% - 2px);
    min-width: calc(50% - 2px);
  }

  /* kill vuetify on focus highlight from expansion header */
  .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus::before {
    opacity: 0;
  }

  >>> .v-icon.krypt.krypt-arrow-down.theme--light {
    color: #0C1016;
  }

  >>> .event-time-cell .v-responsive__sizer {
    transition: unset;
  }
</style>
